import {
    NEWS_PENDING,
    NEWS_FAILED,
    NEWS_DOWNLOADED,
    NEWS_RESET,
    ONE_NEWS_RESET,
    ONE_NEWS_FOCUS,
    ONE_NEWS_DOWNLOADED,
    ONE_NEWS_FAILED,
    ONE_NEWS_DELETING,
    ONE_NEWS_DELETED,
    ONE_NEWS_EDITING,
    ONE_NEWS_POSTING,
    ONE_NEWS_MEDIA_FOCUS,
    ONE_NEWS_MEDIA_UPLOADING,
    ONE_NEWS_MEDIA_FAILED,
    ONE_NEWS_MEDIA_UPLOADED,
    ONE_NEWS_MEDIA_DELETING,
    ONE_NEWS_MEDIA_DELETED
} from "./types";

import LangService from '../../services/lang';

export const INITIAL_STATE = {
    error: null,
    content: LangService.defaultTranslatedContent,
    deletingMedia: false,
    pending: false,
    sending: false,
    currentIndex: null,
    currentNews: null,
    currentMedia: null,
    pendingMedias: [],
    uploadedMedias: [],
    failedMedias: []
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case NEWS_RESET:
            return INITIAL_STATE;
        case ONE_NEWS_RESET:
            return {
                ...state,
                error: null,
                sending: false,
                currentIndex: 0,
                currentNews: null
            };
        case ONE_NEWS_POSTING:
            return {
                ...state,
                sending: true
            };
        case ONE_NEWS_EDITING:
            return {
                ...state,
                sending: true
            };
        case ONE_NEWS_DELETING:
            return {
                ...state,
                sending: true
            };
        case ONE_NEWS_DELETED:
            let newState = {
                ...state,
                sending: false
            };

            LangService.langs.forEach(function (l) {
                if (newState.content[l.key] !== undefined) {
                    newState.content[l.key] = state.content[l.key].filter((oneNews) => {
                        return oneNews.id !== action.payload.id;
                    });
                }
            });

            if (state.currentNews) {
                if (state.currentNews.id === action.payload.id) {
                    newState.currentNews = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content[action.payload.lang].findIndex((oneNews) => {
                        return newState.currentNews.id === oneNews.id
                    });
                }
            }

            return newState;
        case NEWS_PENDING:
            return {
                ...state,
                pending: true
            };
        case NEWS_DOWNLOADED:
            let newContentNews = {...state.content};
            newContentNews[action.payload.lang] = action.payload.news;
            /*let newCurrentNews = null;
            if (state.currentNews) {
                let index = newContentNews[action.payload.lang].findIndex(stateNews => {
                    return stateNews.id === state.currentNews.id;
                });
                newCurrentNews = newContentNews[action.payload.lang][index];
            }*/
            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContentNews,
                //currentNews: newCurrentNews
            };
        case ONE_NEWS_DOWNLOADED:
            let newIndex;
            let id = action.payload.oneNews.id;
            let oneNews = state.content[action.payload.lang].find(function (oneNews) {
                return oneNews.id === id
            });
            let newContent = {...state.content};
            if (oneNews) {
                let index = state.content[action.payload.lang].findIndex(stateOneNews => {
                    return stateOneNews.id === oneNews.id
                });
                newContent[action.payload.lang][index] = action.payload.oneNews;
                newIndex = index;
            } else {
                newContent[action.payload.lang] = [
                    ...state.content[action.payload.lang],
                    action.payload.oneNews
                ];
                newIndex = newContent[action.payload.lang].length - 1;
            }

            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentNews: action.payload.oneNews,
                currentIndex: newIndex
            };
        case ONE_NEWS_FAILED:
            return {
                ...state,
                deletingMedia: false,
                pending: false,
                sending: false,
                error: action.payload,
                currentNews: null,
                currentIndex: 0
            };
        case ONE_NEWS_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content[action.payload.lang].findIndex(oneNews => {
                    return oneNews.id === action.payload.oneNews.id
                }),
                currentNews: action.payload.oneNews
            };
        case NEWS_FAILED:
            return {
                ...state,
                pending: false,
                error: action.payload
            };
        case ONE_NEWS_MEDIA_FOCUS:
            return {
                ...state,
                error: null,
                pending: false,
                currentMedia: action.payload
            };
        case ONE_NEWS_MEDIA_UPLOADING:
            return {
                ...state,
                pendingMedias: [
                    ...state.pendingMedias,
                    action.payload
                ],
                sending: true
            };
        case ONE_NEWS_MEDIA_UPLOADED:
            return {
                ...state,
                pendingMedias: state.pendingMedias.filter((media) => {
                    return media !== action.payload
                }),
                uploadedMedias: [
                    ...state.uploadedMedias,
                    action.payload
                ],
                sending: false,
                currentMedia: action.payload
            };
        case ONE_NEWS_MEDIA_FAILED:
            return {
                ...state,
                pendingMedias: state.pendingMedias.filter((media) => {
                    return media !== action.payload
                }),
                failedMedias: [
                    ...state.failedMedias,
                    action.payload
                ],
                currentMedia: action.payload
            };
        case ONE_NEWS_MEDIA_DELETING:
            return {
                ...state,
                deletingMedia: true
            };
        case ONE_NEWS_MEDIA_DELETED:
            const oneNewsMediaDeleted = {...state.currentNews};
            oneNewsMediaDeleted.medias = oneNewsMediaDeleted.medias.filter((media) => media.id !== action.payload);

            return {
                ...state,
                deletingMedia: false,
                currentNews: oneNewsMediaDeleted,
                currentMedia: null
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/news/reducers.js